import { useState } from "react";

const Quickflowsforinstagram = () => {
  const [activeTab, setActiveTab] = useState("Price Please");

  return (
<div className="container-fluid mt-4 p-4 border rounded" style={{ maxHeight: "85vh", overflow: "auto" }}>


      <div className="d-flex align-items-center justify-content-between row border-bottom ">

      <div className="mb-3 d-flex align-items-center col-md-8">
  {/* Icon Section */}
  <div className="me-3">
    <h2 className="m-0">
      <i className="bi bi-stars"></i>
    </h2>
  </div>

  {/* Text Content Section */}
  <div className="header-text-content">
    <h6 className="m-0">Quick Flows for Instagram</h6>
    <p className="small m-0">
      Enable pre-set Instagram quick flows in 3-4 simple steps!{" "}
      <a href="#">Learn more</a>
    </p>
  </div>
</div>


      <div className="mb-3 col-md-3  d-flex align-items-center gap-4    ">
        <h3><i class="bi bi-youtube"></i></h3>
        <button className="btn btn-light text-dark">  <i className="bi bi-plus-lg me-1"></i> Create New</button>

      </div>
         </div>


      <div className="mb-3">
        <div className="flex mt-4">
        <button
          className={`btn btn-sm me-2 border rounded ${
            activeTab === "Price Please" ? "btn-success" : "btn-outline-success"
          }`}
          onClick={() => setActiveTab("Price Please")}
        >
          Price Please
        </button>

        <button
          className={`btn btn-sm border rounded ${
            activeTab === "Giveaway" ? "btn-success" : "btn-outline-success"
          }`}
          onClick={() => setActiveTab("Giveaway")}
        >
          Giveaway
        </button>
      </div>
      </div>


      {activeTab === "Price Please" && (
        
        <div className="p-4  text-muted text-center" >

          <p>Instagram PP Automations you create will be displayed here. Set one up to streamline your post interactions!</p>
          <button className="btn btn-light text-dark"><i class="bi bi-plus-lg"></i> Create new</button>
        </div>


      )}

      {activeTab === "Giveaway" && (
        <div className="p-4  text-muted text-center">

        <p>      Giveaway Automations you create will be displayed here. Set one up to streamline your post interactions!
        </p>
        <button className="btn btn-light text-dark"><i class="bi bi-plus-lg"></i> Create new</button>
      </div>

      )}
    </div>
  );
}


export default Quickflowsforinstagram